import { ComponentType } from '../types';
const CUSTOM_COMPONENTS = new Set([ComponentType.Text]);
const EDITABLE_TEXT_COMPONENTS = new Set([ComponentType.Text, ComponentType.TextMarquee, ComponentType.SiteButton]);
const STYLE_PROPERTY_COMPONENTS = new Set([ComponentType.SiteButton, ComponentType.Container, ComponentType.Page, ComponentType.Repeater, ComponentType.TextMarquee, ComponentType.FiveGridLine, ComponentType.PopupCloseIconButton, ComponentType.VerticalLine, ComponentType.StylableButton]);
const DESIGN_PROPERTY_COMPONENTS = new Set([ComponentType.Column, ComponentType.ClassicSection, ComponentType.ResponsiveSection, ComponentType.MasterPage, ComponentType.StateBox, ComponentType.StateBoxState, ComponentType.BoxSlideShow, ComponentType.StripContainerSlideShow, ComponentType.BoxSlideShowSlide, ComponentType.StripContainerSlideShowSlide, ComponentType.StripColumnsContainer, ComponentType.ResponsiveHeader, ComponentType.ResponsiveFooter, ComponentType.PopupContainer, ComponentType.MediaContainer, ComponentType.HeaderContainer, ComponentType.FooterContainer]);
// Type representing the source from which a component's style should be resolved or updated.
export let ComponentStyleSource = /*#__PURE__*/function (ComponentStyleSource) {
  ComponentStyleSource["CUSTOM"] = "CUSTOM";
  ComponentStyleSource["STYLE"] = "STYLE";
  ComponentStyleSource["DESIGN"] = "DESIGN";
  ComponentStyleSource["UNKNOWN"] = "UNKNOWN";
  return ComponentStyleSource;
}({});
export const getComponentStyleSource = componentType => {
  if (CUSTOM_COMPONENTS.has(componentType)) {
    return ComponentStyleSource.CUSTOM;
  }
  if (STYLE_PROPERTY_COMPONENTS.has(componentType)) {
    return ComponentStyleSource.STYLE;
  }
  if (DESIGN_PROPERTY_COMPONENTS.has(componentType)) {
    return ComponentStyleSource.DESIGN;
  }
  return ComponentStyleSource.UNKNOWN;
};
export const getEditableTextComponentStyleSource = componentType => {
  if (!EDITABLE_TEXT_COMPONENTS.has(componentType)) {
    return ComponentStyleSource.UNKNOWN;
  }
  if (CUSTOM_COMPONENTS.has(componentType)) {
    return ComponentStyleSource.CUSTOM;
  }
  if (STYLE_PROPERTY_COMPONENTS.has(componentType)) {
    return ComponentStyleSource.STYLE;
  }
  if (DESIGN_PROPERTY_COMPONENTS.has(componentType)) {
    return ComponentStyleSource.DESIGN;
  }
  return ComponentStyleSource.UNKNOWN;
};
//# sourceMappingURL=get-component-style-source.js.map